import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, X as XIcon, Loader2 } from 'lucide-react';
import { AnimatePresence } from 'framer-motion';
import { sendDemoEmail, DemoFormData } from '../lib/sendDemoEmail';
const roles = ['Mill Owner / Manufacturer', 'Trader / Broker', 'Exporter / Importer', 'Retailer / Brand', 'Investor', 'Other'];
function DemoModal({
  onClose
}: {
  onClose: () => void;
}) {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState<DemoFormData>({
    name: '',
    email: '',
    phone: '',
    role: '',
    company: ''
  });
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await sendDemoEmail(form);
      setSubmitted(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} data-id="element-243">
      <motion.div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-244" />
      <motion.div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" initial={{
      opacity: 0,
      scale: 0.94,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.94,
      y: 20
    }} transition={{
      ease: [0.34, 1.56, 0.64, 1],
      duration: 0.4
    }} data-id="element-245">
        <button onClick={onClose} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-[#F5F4F0] flex items-center justify-center hover:bg-[#E8E4DC] transition-colors z-10" data-id="element-246">
          <XIcon className="w-4 h-4 text-[#5C5A55]" data-id="element-247" />
        </button>
        {!submitted ? <div className="p-8" data-id="element-248">
            <div className="mb-6" data-id="element-249">
              <h2 className="font-jakarta text-2xl font-extrabold text-[#0F0E0C] mb-1" data-id="element-250">
                Request a Demo
              </h2>
              <p className="text-sm text-[#9B9890] font-inter" data-id="element-251">
                Our team will get in touch with you shortly.
              </p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-252">
              {[{
            label: 'Full Name',
            key: 'name',
            type: 'text',
            placeholder: 'Rahul Sharma',
            required: true
          }, {
            label: 'Email',
            key: 'email',
            type: 'email',
            placeholder: 'rahul@company.com',
            required: true
          }, {
            label: 'Phone Number',
            key: 'phone',
            type: 'tel',
            placeholder: '+91 98765 43210',
            required: true
          }].map(field => <div key={field.key} data-id="element-253">
                  <label className="block text-xs font-inter font-semibold text-[#5C5A55] mb-1.5 uppercase tracking-wide" data-id="element-254">
                    {field.label} *
                  </label>
                  <input type={field.type} required value={(form as any)[field.key]} onChange={e => setForm({
              ...form,
              [field.key]: e.target.value
            })} placeholder={field.placeholder} className="w-full px-4 py-2.5 rounded-xl border border-[#E8E4DC] bg-[#FAFAF8] text-[#0F0E0C] text-sm font-inter focus:outline-none focus:border-[#E8500A] focus:ring-2 focus:ring-[#E8500A]/10 transition-all" data-id="element-255" />
                </div>)}
              <div data-id="element-256">
                <label className="block text-xs font-inter font-semibold text-[#5C5A55] mb-1.5 uppercase tracking-wide" data-id="element-257">
                  Role *
                </label>
                <select required value={form.role} onChange={e => setForm({
              ...form,
              role: e.target.value
            })} className="w-full px-4 py-2.5 rounded-xl border border-[#E8E4DC] bg-[#FAFAF8] text-[#0F0E0C] text-sm font-inter focus:outline-none focus:border-[#E8500A] focus:ring-2 focus:ring-[#E8500A]/10 transition-all appearance-none" data-id="element-258">
                  <option value="" data-id="element-259">Select your role</option>
                  {roles.map(r => <option key={r} value={r} data-id="element-260">
                      {r}
                    </option>)}
                </select>
              </div>
              <div data-id="element-261">
                <label className="block text-xs font-inter font-semibold text-[#5C5A55] mb-1.5 uppercase tracking-wide" data-id="element-262">
                  Company
                </label>
                <input type="text" value={form.company} onChange={e => setForm({
              ...form,
              company: e.target.value
            })} placeholder="Your company name" className="w-full px-4 py-2.5 rounded-xl border border-[#E8E4DC] bg-[#FAFAF8] text-[#0F0E0C] text-sm font-inter focus:outline-none focus:border-[#E8500A] focus:ring-2 focus:ring-[#E8500A]/10 transition-all" data-id="element-263" />
              </div>

              {error && <p className="text-xs text-red-500 font-inter bg-red-50 px-3 py-2 rounded-lg" data-id="element-264">
                  {error}
                </p>}

              <motion.button type="submit" disabled={loading} whileHover={!loading ? {
            scale: 1.02
          } : {}} whileTap={!loading ? {
            scale: 0.98
          } : {}} className="w-full py-3 bg-[#E8500A] hover:bg-[#D14508] disabled:opacity-60 disabled:cursor-not-allowed text-white font-inter font-semibold rounded-xl transition-colors mt-2 flex items-center justify-center gap-2" data-id="element-265">
                {loading ? <>
                    <Loader2 className="w-4 h-4 animate-spin" data-id="element-266" />
                    Sending...
                  </> : 'Request Demo'}
              </motion.button>
            </form>
          </div> : <div className="p-8 text-center" data-id="element-267">
            <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 15
        }} className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4" data-id="element-268">
              <CheckCircle2 className="w-8 h-8 text-green-600" data-id="element-269" />
            </motion.div>
            <h3 className="font-jakarta text-xl font-extrabold text-[#0F0E0C] mb-2" data-id="element-270">
              Request Received!
            </h3>
            <p className="text-sm text-[#5C5A55] font-inter leading-relaxed mb-6" data-id="element-271">
              Our team will get in touch with you shortly.
            </p>
            <motion.button onClick={onClose} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="px-6 py-2.5 bg-[#0F0E0C] text-white font-inter font-semibold rounded-xl text-sm" data-id="element-272">
              Close
            </motion.button>
          </div>}
      </motion.div>
    </motion.div>;
}
export function Hero() {
  const [modalOpen, setModalOpen] = useState(false);
  return <>
      <section className="relative pt-28 pb-20 md:pt-36 md:pb-28 overflow-hidden bg-[#FAFAF8]" data-id="element-273">
        {/* Subtle background */}
        <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" data-id="element-274" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-[#E8500A]/5 rounded-full blur-3xl -z-10" data-id="element-275" />

        <div className="max-w-6xl mx-auto px-5 lg:px-8" data-id="element-276">
          <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-277">
            {/* Logo */}
            <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="mb-8" data-id="element-278">
              <img src="https://cdn.magicpatterns.com/uploads/gPkoxER8MRU5GSVk7bdedN/LogoBlack.fdf2fa00.svg" alt="The Yarn Bazaar" className="h-10 w-auto mx-auto" data-id="element-279" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            y: -8
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            ease: [0.34, 1.56, 0.64, 1]
          }} className="mb-6" data-id="element-280">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#E8500A]/20 bg-[#E8500A]/5 text-[#E8500A] text-sm font-inter font-medium" data-id="element-281">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E8500A] pulse-dot" data-id="element-282" />
                India's #1 B2B Yarn Marketplace
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="font-jakarta text-5xl md:text-7xl font-extrabold text-[#0F0E0C] mb-6 leading-[1.05] tracking-tight" data-id="element-283">
              Where India's Yarn
              <br data-id="element-284" />
              <span className="gradient-text" data-id="element-285">Trade Happens</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg md:text-xl text-[#5C5A55] font-inter mb-10 max-w-2xl leading-relaxed" data-id="element-286">
              Connecting mills, traders, and exporters across India and beyond.
              Discover, negotiate, and transact yarn — all in one place.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-287">
              <motion.button onClick={() => setModalOpen(true)} whileHover={{
              scale: 1.04
            }} whileTap={{
              scale: 0.97
            }} className="magnetic-btn inline-flex items-center gap-2 px-8 py-4 bg-[#E8500A] hover:bg-[#D14508] text-white font-jakarta font-bold rounded-full text-base transition-colors shadow-lg shadow-[#E8500A]/20" data-id="element-288">
                Request Demo
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-289">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-290" />
                </svg>
              </motion.button>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.5,
            delay: 0.45
          }} className="mt-8 flex flex-wrap items-center justify-center gap-6 text-sm text-[#9B9890] font-inter" data-id="element-291">
              <span className="flex items-center gap-2" data-id="element-292">
                <CheckCircle2 className="h-4 w-4 text-[#E8500A]" data-id="element-293" />
                Mumbai, India
              </span>
              <span className="flex items-center gap-2" data-id="element-294">
                <CheckCircle2 className="h-4 w-4 text-[#E8500A]" data-id="element-295" />
                Shark Tank India · Season 1
              </span>
              <span className="flex items-center gap-2" data-id="element-296">
                <CheckCircle2 className="h-4 w-4 text-[#E8500A]" data-id="element-297" />
                1000+ Active Buyers
              </span>
            </motion.div>
          </div>
        </div>
      </section>

      <AnimatePresence data-id="element-298">
        {modalOpen && <DemoModal onClose={() => setModalOpen(false)} data-id="element-299" />}
      </AnimatePresence>
    </>;
}